import { css, unsafeCSS } from 'lit';
import * as color from '@cof/gravity-tokens/dist/default/mjs/color';

// Default coloring high emphasis coloring
const highEmphasisBgColor = color.colorBackgroundInteractiveEmphasisHigh;
const highEmphasisBgDisabledColor = color.colorBackgroundInactiveEmphasisLow;
const highEmphasisHoverColor =
  color.colorBackgroundInteractiveEmphasisHighHover;
const highEmphasisActiveColor =
  color.colorBackgroundInteractiveEmphasisHighPress;
const highEmphasisTextColor = color.colorTextAndIconInverse;

// Default coloring low emphasis coloring
const lowEmphasisBgColor = color.colorBackgroundInteractiveEmphasisNone;
const lowEmphasisBgDisabledColor = color.colorBackgroundTransparent;
const lowEmphasisTextColor = color.colorTextAndIconInteractive;
const lowEmphasisHoverColor = color.colorBackgroundInteractiveEmphasisNoneHover;
const lowEmphasisHoverTextColor = color.colorTextAndIconInteractiveHover;
const lowEmphasisActiveColor =
  color.colorBackgroundInteractiveEmphasisNonePress;
const lowEmphasisActiveTextColor = color.colorTextAndIconInteractivePress;

const textDisabledColor = color.colorTextAndIconInactive;

export const DxoStylesButton = css`
  :host {
    --high-emphasis-bg-color: ${unsafeCSS(highEmphasisBgColor)};
    --high-emphasis-bg-disabled-color: ${unsafeCSS(
      highEmphasisBgDisabledColor
    )};
    --high-emphasis-hover-color: ${unsafeCSS(highEmphasisHoverColor)};
    --high-emphasis-active-color: ${unsafeCSS(highEmphasisActiveColor)};
    --high-emphasis-text-color: ${unsafeCSS(highEmphasisTextColor)};

    --low-emphasis-bg-color: ${unsafeCSS(lowEmphasisBgColor)};
    --low-emphasis-bg-disabled-color: ${unsafeCSS(lowEmphasisBgDisabledColor)};
    --low-emphasis-text-color: ${unsafeCSS(lowEmphasisTextColor)};
    --low-emphasis-hover-color: ${unsafeCSS(lowEmphasisHoverColor)};
    --low-emphasis-text-hover-color: ${unsafeCSS(lowEmphasisHoverTextColor)};
    --low-emphasis-active-color: ${unsafeCSS(lowEmphasisActiveColor)};
    --low-emphasis-text-active-color: ${unsafeCSS(lowEmphasisActiveTextColor)};

    --text-disabled-color: ${unsafeCSS(textDisabledColor)};
  }

  @font-face {
    font-family: 'Optimist', Helvetica, Arial, sans-serif;
    src: url('/fonts/Optimist_W_XLt.woff') format('woff'),
      url('/fonts/Optimist_W_XLt.woff2') format('woff2');
    font-weight: 200;
    font-style: normal;
  }
  html {
    font-family: 'Optimist', Helvetica, Arial, sans-serif;
    font-weight: normal;
    font-style: normal;
  }

  /* Button Styles */

  /* Primary */
  .button-primary {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: #e3245a;
    border: 1px solid #e3245a;
    color: #ffffff;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-primary:disabled {
    background-color: #ecedf1;
    border: 1px solid #ecedf1;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-primary.button-compact {
    padding: 3px 1rem;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-primary.button-full-width {
    width: 100%;
  }
  .button-primary:hover:enabled {
    background-color: #b51c48;
    border: 1px solid #b51c48;
  }

  /* Secondary */
  .button-secondary {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: #ffffff;
    border: 1px solid #e3245a;
    color: #e3245a;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-secondary:disabled {
    background-color: #ecedf1;
    border: 1px solid #ecedf1;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-secondary.button-compact {
    padding: 3px 1rem;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-secondary.button-full-width {
    width: 100%;
  }
  .button-secondary:hover:enabled {
    background-color: #b51c48;
    border: 1px solid #b51c48;
    color: #ffffff;
  }

  /* Inverse */
  .button-inverse {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-inverse:disabled {
    background-color: #ecedf1;
    border: 1px solid #ecedf1;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-inverse.button-compact {
    padding: 3px 1rem;
    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-inverse.button-full-width {
    width: 100%;
  }
  .button-inverse:hover:enabled {
    background-color: #ffffff;
    border: 1px solid #ffffff;
    color: #e3245a;
  }

  /* Destructive */
  .button-destructive {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: #ab0000;
    border: 1px solid #ab0000;
    color: #ffffff;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-destructive:disabled {
    background-color: #ecedf1;
    border: 1px solid #ecedf1;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-destructive.button-compact {
    padding: 3px 1rem;
    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-destructive.button-full-width {
    width: 100%;
  }
  .button-destructive:hover:enabled {
    background-color: #8b0000;
    border: 1px solid #8b0000;
  }

  /* Regressive */
  .button-regressive {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: #687680;
    border: 1px solid #687680;
    color: #ffffff;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-regressive:disabled {
    background-color: #ecedf1;
    border: 1px solid #ecedf1;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-regressive.button-compact {
    padding: 3px 1rem;
    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-regressive.button-full-width {
    width: 100%;
  }
  .button-regressive:hover:enabled {
    background-color: #273b49;
    border: 1px solid #273b49;
  }

  /* Gravity Primary */
  .button-gravity-primary {
    padding: 0.75rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: #0276b1;
    border: 0px;
    color: #ffffff;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-gravity-primary:disabled {
    background-color: #ecedf1;
    border: 0px;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-gravity-primary.button-compact {
    padding: 3px 1rem;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-gravity-primary.button-full-width {
    width: 100%;
  }
  .button-gravity-primary:hover:enabled {
    background-color: #026597;
    border: 0px;
  }

  /* Gravity Secondary */
  .button-gravity-secondary {
    padding: 0.75rem 1rem;
    border-radius: 4px;
    text-transform: none;
    cursor: pointer;
    background-color: #ffffff;
    border: 1px solid #0276b1;
    color: #0276b1;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
  }
  .button-gravity-secondary:disabled {
    background-color: #ecedf1;
    border: 1px solid #ecedf1;
    color: #9c9b9b;
    cursor: not-allowed;
  }
  .button-gravity-secondary.button-compact {
    padding: 3px 1rem;

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    font-size: 1rem;
    line-height: 24px;
  }
  .button-gravity-secondary.button-full-width {
    width: 100%;
  }
  .button-gravity-secondary:hover:enabled {
    background-color: #026597;
    border: 1px solid #026597;
    color: #ffffff;
  }

  /** Gravity 3 Base */
  .grv-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    padding: 0.75rem 1rem;

    background: var(--high-emphasis-bg-color);
    color: var(--high-emphasis-text-color);

    font-family: Optimist, "Helvetica Neue", Arial, sans-serif;
    line-height: 24px;
    font-size: 1rem;
    cursor: pointer;
  }

  .grv-button.button-compact {
    padding: 3px 1rem;
  }
  .grv-button.button-full-width {
    width: 100%;
  }
  .grv-button:disabled {
    background-color: var(--high-emphasis-bg-disabled-color);
    border: 1px solid var(--high-emphasis-bg-disabled-color);
    color: var(--text-disabled-color);
    cursor: not-allowed;
  }
  .grv-button:focus:enabled {
    box-shadow: 0px 0px 0px 2px #ffffff,
      0px 0px 0px 4px var(--high-emphasis-bg-color);
  }

  /* Gravity 3 Primary */
  .grv-button.primary {
    background-color: var(--high-emphasis-bg-color);
    border: 1px solid var(--high-emphasis-bg-color);
    color: var(--high-emphasis-text-color);
  }

  .grv-button.primary:hover:enabled {
    background-color: var(--high-emphasis-hover-color);
    border: 1px solid var(--high-emphasis-hover-color);
  }
  .grv-button.primary:active:enabled {
    background-color: var(--high-emphasis-active-color);
    border: 1px solid var(--high-emphasis-active-color);
  }
  .grv-button.primary:disabled {
    background-color: var(--high-emphasis-bg-disabled-color);
    border: 1px solid var(--high-emphasis-bg-disabled-color);
    color: var(--text-disabled-color);
    cursor: not-allowed;
  }

  /* Gravity 3 Secondary */
  .grv-button.secondary {
    background-color: var(--low-emphasis-bg-color);
    border: 1px solid var(--low-emphasis-text-color);
    color: var(--low-emphasis-text-color);
  }

  .grv-button.secondary:hover:enabled {
    background-color: var(--low-emphasis-hover-color);
    border: 1px solid var(--low-emphasis-text-hover-color);
    color: var(--low-emphasis-text-hover-color);
  }
  .grv-button.secondary:active:enabled {
    background-color: var(--low-emphasis-active-color);
    border: 1px solid var(--low-emphasis-text-active-color);
    color: var(--low-emphasis-text-active-color);
  }
  .grv-button.secondary:disabled {
    background-color: var(--low-emphasis-bg-disabled-color);
    border: 1px solid var(--text-disabled-color);
    color: var(--text-disabled-color);
    cursor: not-allowed;
  }

  /* Gravity 3 Tertiary */
  .grv-button.tertiary {
    background-color: var(--low-emphasis-bg-color);
    border: 1px solid var(--low-emphasis-bg-color);
    color: var(--low-emphasis-text-color);
  }

  .grv-button.tertiary:hover:enabled {
    background-color: var(--low-emphasis-hover-color);
    border: 1px solid var(--low-emphasis-hover-color);
  }
  .grv-button.tertiary:active:enabled {
    background-color: var(--low-emphasis-active-color);
    border: 1px solid var(--low-emphasis-active-color);
  }
  .grv-button.tertiary:disabled {
    background-color: var(--low-emphasis-bg-disabled-color);
    border: 1px solid var(--low-emphasis-bg-disabled-color);
    color: var(--text-disabled-color);
    cursor: not-allowed;
  }
`;
